import { httpObjQueryString } from "../config/httpClient";
import { setDataParams, SetGateWay } from "./gateway";
import localStorageService from "../../services/localStorageService";

const { httpGateWay } = SetGateWay();
const httpClient = httpGateWay;
export const createKerryOrderApi = (order, data) => {
  const localStorage = localStorageService.getService();
  const domain = localStorage.getConfig();
  const orderId = {
    orderId: order,
    address: data.address,
    prefix: domain?.prefix ?? "",
  };
  // console.log(orderId)
  return httpClient.post(`/kerry/order/create`, orderId);
};

export const cancelKerryOrderApi = (data) => {
  const orderId = {
    orderId: data,
  };
  return httpClient.post(`/kerry/order/cancel`, setDataParams(orderId));
};
export const updateKerryTrackingOrderApi = (data) => {
  return httpClient.post(`/kerry/order/tracking/update`, setDataParams(data));
};

export const trackingKerryOrderApi = (id) => {
  return httpClient.get(`/kerry/order/tracking/${id}`);
};

export const printKerryOrderApi = (data) => {
  const orderId = {
    orderId: data.orderId,
    type: data.type,
  };
  return httpClient.post(`/kerry/order/print`, setDataParams(orderId));
};
